<template>
  <BaseModal
    ref="BaseModal"
    backdrop="static"
    size="modal-xl"
    title="Visualizador"
    class="lightbox-modal"
  >
    <template v-slot:header>
      <div class="d-flex align-items-center w-100 justify-content-between">
        <div class="d-flex align-items-center">
          <div class="btn btn-primary mr-2" @click="download(current_entry)">
            <i class="la la-download"></i>
            <span>Download</span>
          </div>
          <h5 class="modal-title">{{ current_entry.name }}</h5>
        </div>
        <div class="text-muted mr-3">
          {{ index + 1 }} / {{ entries.length }}
        </div>
      </div>
    </template>

    <div class="lightbox-container">
      <div v-if="entries.length > 1" class="nav-button prev" @click="prev()">
        <i class="la la-chevron-left"></i>
      </div>

      <div class="content-wrapper">
        <img v-if="getType(current_entry) === 'image'" :src="file(current_entry)"/>
        <audio v-if="getType(current_entry) === 'audio'" :src="file(current_entry)" autoplay controls/>
        <video v-if="getType(current_entry) === 'video'" :src="file(current_entry)" autoplay controls/>
        <div v-if="!['image', 'audio', 'video'].includes(getType(current_entry))" class="text-white">
          Este arquivo não pode ser pré-visualizado.
        </div>
      </div>

      <div v-if="entries.length > 1" class="nav-button next" @click="next()">
        <i class="la la-chevron-right"></i>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import {getEntryType} from '../common'
import BaseModal from '../components/BaseModal'

export default {
  name: 'ImageView',
  components: {BaseModal},
  data () {
    return {
      param: {},
      entries: [],
      index: 0
    }
  },
  computed: {
    current_entry () {
      return this.entries[this.index] || {}
    }
  },
  mounted () {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    show ({param, entries, index}) {
      this.param = param
      this.entries = entries || []
      this.index = index || 0
      this.$refs.BaseModal.show()
    },
    prev () {
      if (this.index > 0) {
        this.index--
      } else {
        this.index = this.entries.length - 1
      }
    },
    next () {
      if (this.index < this.entries.length - 1) {
        this.index++
      } else {
        this.index = 0
      }
    },
    handleKeydown (e) {
      if (!this.$refs.BaseModal || !$(this.$refs.BaseModal.$el).hasClass('show')) {return}

      if (e.key === 'ArrowLeft') {
        this.prev()
      } else if (e.key === 'ArrowRight') {
        this.next()
      }
    },
    getType (entry) {
      return getEntryType(entry)
    },
    getImg (entry) {
      const type = getEntryType(entry)

      if (type === 'image') {
        return this.file(entry)
      }

      if (entry.folder) {
        return '/img/folder.svg'
      }

      if (type === 'txt') {
        return '/img/txt.svg'
      }

      if (type === 'video') {
        return '/img/video.svg'
      }

      if (type === 'audio') {
        return '/img/audio.svg'
      }

      if (type === 'doc') {
        return '/img/doc.svg'
      }

      if (type === 'xls') {
        return '/img/xls.svg'
      }

      if (type === 'pdf') {
        return '/img/pdf.svg'
      }
      if (type === 'zip') {
        return '/img/zip.svg'
      }

      return '/img/default-file.svg'
    },
    file (entry) {
      return '/media/file?q=' + btoa(JSON.stringify({
        param: this.param,
        path: entry.path
      }))
    },
    download (entry) {
      const opts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify({
          param: this.param,
          path: entry.path
        })
      }
      fetch('/download', opts)
        .then(resp => resp.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          // the filename you want
          a.download = entry.name
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
          // alert('your file has downloaded!') // or you know, something with better UX...
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.lightbox-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 400px;
    background: #1a1a1a;
    margin: -1rem; /* Contrapor o padding do modal-body */
}

.content-wrapper {
    width: 100%;
    max-height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;

    img, video {
        max-width: 90%;
        max-height: 70vh;
        object-fit: contain;
    }
}

.nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.5);
    color: white;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 50%;
    transition: background 0.3s;
    z-index: 10;
    font-size: 24px;

    &:hover {
        background: rgba(0, 0, 0, 0.8);
    }

    &.prev {
        left: 20px;
    }

    &.next {
        right: 20px;
    }
}

::v-deep {
    .modal-content {
        background-color: #1a1a1a !important;
        color: white;
    }
    .modal-header {
        border-bottom: 1px solid #333;
        color: white;
        .close {
            color: white;
            text-shadow: none;
            opacity: 0.8;
            &:hover {
                opacity: 1;
            }
        }
    }
    .modal-footer {
        border-top: 1px solid #333;
        display: none; /* Esconder footer padrão se não for necessário */
    }
}
</style>
